export { default } from "./character-count";
